<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      Historique des flux GEF
    </div>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [columnAutoWidth]="true"
  [dataSource]="gefHistoryList"
  keyExpr="id"
  class="data-grid"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  columnResizingMode="widget"
>
  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxi-column dataField="operation" alignment="center" caption="Flux"  ></dxi-column>
  <dxi-column dataField="description" alignment="center" caption="Status"
              cellTemplate="gefStatusCellTemplate"></dxi-column>
  <dxi-column dataField="args" [width]="500" alignment="left" caption="Logs" cellTemplate="gefLogsCellTemplate"></dxi-column>
  <dxi-column dataField="dateEvent" alignment="center" caption="Date d'éxécution" ></dxi-column>

  <div *dxTemplate="let cell of 'gefStatusCellTemplate'">
    <span [ngClass]="{
    'status-success': cell.row.data.description === 'SUCCESS',
    'status-warning': cell.row.data.description === 'WARNING',
    'status-error': cell.row.data.description === 'ERROR'
    }">{{ cell.row.data.description }}</span>
  </div>

  <div *dxTemplate="let cell of 'gefLogsCellTemplate'">
    <div (click)="openLogsDialog(cell.row.data.args)">
      <span class="genLabel cursor">{{cell.row.data.args}}</span>
    </div>
  </div>

  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[50, 100, 200]"
    [visible]="true"
    [showInfo]="true">
  </dxo-pager>

</dx-data-grid>


<dx-popup
  [showTitle]="true"
  [title]="'Détails des logs'"
  [(visible)]="displayDialog"
  (onHiding)="closeLogsDialog()"
  [width]="700"
  [height]="600"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  [dragEnabled]="true"
>
  <div *ngFor="let item of selectedLogs">
    <strong>{{ item.key }}:</strong> {{ item.value }}
  </div>

</dx-popup>
